<form [formGroup]="billingForm" (ngSubmit)="onSubmit()" class="p-fluid">
	<!-- BUSINESS INFO -->
	<p-panel header="Business Information">
		<div class="grid formgrid">
			<div class="field col-12 md:col-6">
				<label for="name">Billing Name</label>
				<input
					id="name"
					pInputText
					formControlName="name"
					readonly
				/>
				<small class="p-text-secondary">
					Contact support to change
				</small>
			</div>
		</div>
	</p-panel>

	<br />

	<!-- PRIMARY CONTACT -->
	<p-panel header="Primary Contact">
		<div class="grid formgrid">
			<div class="field col-12 md:col-4">
				<label for="firstName">First Name *</label>
				<input
					id="firstName"
					pInputText
					formControlName="firstName"
				/>
				<small *ngIf="isInvalid('firstName')" class="p-error">
					Required
				</small>
			</div>

			<div class="field col-12 md:col-4">
				<label for="lastName">Last Name *</label>
				<input
					id="lastName"
					pInputText
					formControlName="lastName"
				/>
				<small *ngIf="isInvalid('lastName')" class="p-error">
					Required
				</small>
			</div>

			<div class="field col-12 md:col-4">
				<label for="emailAddress">Email *</label>
				<input
					id="emailAddress"
					pInputText
					formControlName="emailAddress"
					readonly
				/>
				<small class="p-text-secondary">
					Contact support to change
				</small>
			</div>
		</div>
	</p-panel>

	<br />

	<!-- SECONDARY CONTACT TOGGLE -->
	<div class="field-checkbox mt-2 flex align-items-center gap-2">
		<p-checkbox
			formControlName="addSecondaryContact"
			binary="true"
			inputId="addSecondaryContact"
			(onChange)="onToggleSecondaryContact($event.checked)"
		></p-checkbox>
		<label for="addSecondaryContact">
			Add an additional email to send a copy of invoices
		</label>
	</div>

	<!-- SECONDARY CONTACT -->
	<p-panel
		*ngIf="billingForm.get('addSecondaryContact')?.value"
		header="Secondary Contact"
	>
		<div class="grid formgrid">
			<div class="field col-12 md:col-4">
				<label for="secondaryFirstName">First Name</label>
				<input
					id="secondaryFirstName"
					pInputText
					formControlName="secondaryFirstName"
				/>
			</div>

			<div class="field col-12 md:col-4">
				<label for="secondaryLastName">Last Name</label>
				<input
					id="secondaryLastName"
					pInputText
					formControlName="secondaryLastName"
				/>
			</div>

			<div class="field col-12 md:col-4">
				<label for="secondaryEmailAddress">Email</label>
				<input
					id="secondaryEmailAddress"
					type="email"
					pInputText
					formControlName="secondaryEmailAddress"
					readonly
				/>
				<small class="p-text-secondary">
					Contact support to change
				</small>
			</div>
		</div>

		<div class="field mt-1">
			<p-checkbox
				formControlName="secondaryIncludeInEmails"
				binary="true"
				inputId="secondaryIncludeInEmails"
			></p-checkbox>
			<label for="secondaryIncludeInEmails" class="ml-2">
				Include in invoice emails
			</label>
		</div>
	</p-panel>

	<br *ngIf="billingForm.get('addSecondaryContact')?.value" />

	<!-- BILLING ADDRESS (POBOX) -->
	<p-panel header="Billing Address">
		<div class="field">
			<label for="addressLine1">Address Line 1 *</label>
			<input
				id="addressLine1"
				pInputText
				formControlName="addressLine1"
			/>
			<small *ngIf="isInvalid('addressLine1')" class="p-error">
				Required
			</small>
		</div>

		<div class="grid formgrid">
			<div class="field col-12 md:col-4">
				<label for="city">City *</label>
				<input id="city" pInputText formControlName="city" />
				<small *ngIf="isInvalid('city')" class="p-error">
					Required
				</small>
			</div>

			<div class="field col-12 md:col-4">
				<label for="region">State</label>
				<input id="region" pInputText formControlName="region" />
			</div>

			<div class="field col-12 md:col-4">
				<label for="postalCode">Postcode *</label>
				<input
					id="postalCode"
					pInputText
					formControlName="postalCode"
				/>
				<small *ngIf="isInvalid('postalCode')" class="p-error">
					Required
				</small>
			</div>
		</div>

		<div class="grid formgrid">
			<div class="field col-12 md:col-6">
				<label for="country">Country *</label>
				<input id="country" pInputText formControlName="country" />
				<small *ngIf="isInvalid('country')" class="p-error">
					Required
				</small>
			</div>
		</div>
	</p-panel>

	<br />

	<!-- TAX -->
	<p-panel header="Tax & Payment Details">
		<div class="field col-12 md:col-6">
			<label for="taxNumber">Tax Number</label>
			<input id="taxNumber" pInputText formControlName="taxNumber" />
		</div>
	</p-panel>

	<!-- SUBMIT -->
	<div class="mt-4 flex justify-content-end">
		<button
			pButton
			type="submit"
			[label]="saving ? 'Updating…' : 'Update Billing'"
			class="p-button-primary"
			[disabled]="billingForm.invalid || saving"
		></button>
	</div>
</form>
